module.exports = __webpack_public_path__ + "media/assets/icons/review_user1-a23acbbd79782f062dd32bee9ba33837.svg";